import React, { useState } from 'react';

/**
 * Bulk-delete confirmation with an opt-in "also delete the leads" checkbox.
 * @param {{count: number, busy?: boolean, onCancel: () => void,
 *   onConfirm: (opts: {deleteLeads: boolean}) => void}} props
 * @returns {JSX.Element}
 */
export default function ConfirmDeleteModal({ count, busy = false, onCancel, onConfirm }) {
  const [deleteLeads, setDeleteLeads] = useState(false);
  return (
    <div className="fixed inset-0 z-50 bg-black/70 flex items-center justify-center p-4" role="dialog" aria-modal="true" aria-label="Confirm delete">
      <div className="panel max-w-md w-full p-5 space-y-4">
        <h2 className="text-lg font-semibold">Delete {count} call{count === 1 ? '' : 's'}?</h2>
        <p className="text-sm text-white/60">
          The call records and their recordings will be permanently removed. This can't be undone.
        </p>
        <label className="flex items-start gap-2 text-sm text-white/80">
          <input type="checkbox" checked={deleteLeads} onChange={(e) => setDeleteLeads(e.target.checked)} className="mt-1 accent-rose-500" />
          Also delete the associated leads (only leads you're permitted to delete)
        </label>
        <div className="flex justify-end gap-2">
          <button type="button" onClick={onCancel} className="btn-ghost text-sm px-3 py-1.5">Cancel</button>
          <button
            type="button"
            disabled={busy}
            onClick={() => onConfirm({ deleteLeads })}
            className="px-3 py-1.5 rounded-md bg-rose-600 hover:bg-rose-500 text-sm font-semibold disabled:opacity-50"
          >
            {busy ? 'Deleting…' : 'Delete'}
          </button>
        </div>
      </div>
    </div>
  );
}
